
import XHeader from 'vux/src/components/x-header/index.vue'
import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'

import global from '../../static/js/global.js'
import $ from 'jquery'
export default {
components: {
XHeader,
ButtonTab,
ButtonTabItem,
$
},
data(){
return {
title:'物业缴费',
select1:false,
select2:false,
select3:false,
hidet:false,
hidet1:false,
hidet2:false
}
},
beforeMount(){
let url = global.host + 'pay/findhouse?openid=' + this.$router.history.current.query.openid + "&phone=" + this.$router.history.current.query.phone;
this.$http.get(url).then(function(res){

let urls = global.host + 'feeItem/getList?comnCode=' + res.body.comnCode;

this.$http.get(urls).then(function(res){
let mlit = res.body.result;
for(let m in mlit){
if(mlit[m].feeName == "物业费"){
this.hidet = true;
}else if(mlit[m].feeName == "电费"){
this.hidet1 = true;
}else if(mlit[m].feeName == "水费"){
this.hidet2 = true;
}
}
},function(err){
console.log(err)
})

},function(err){
console.log(err)
})








if(this.$router.history.current.path == '/pay/tenement'){
document.title = "物业缴费";
this.select1 = true
}else if(this.$router.history.current.path == '/pay/electricity'){
document.title = "电费缴纳";
this.select2 = true
}else if(this.$router.history.current.path == '/pay/water'){
document.title = "水费缴纳";
this.select3 = true
}
},
methods:{
changePage(index){
switch(index){
case 0:
this.$router.push({path:'/pay/tenement',query:{openid:this.$router.history.current.query.openid,phone:this.$router.history.current.query.phone,comnCode:this.$router.history.current.query.comnCode}});
break;
/*$(".vux-button-tab-item:eq(0)").addClass("vux-button-group-current").siblings(".vux-button-tab-item").removeClass("vux-button-group-current")
this.title = '物业缴费';*/
case 1:
this.$router.push({path:'/pay/electricity',query:{openid:this.$router.history.current.query.openid,phone:this.$router.history.current.query.phone,comnCode:this.$router.history.current.query.comnCode}});
break;
case 2:
this.$router.push({path:'/pay/water',query:{openid:this.$router.history.current.query.openid,phone:this.$router.history.current.query.phone,comnCode:this.$router.history.current.query.comnCode}});
break;
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/payment.vue